"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../../../");
require("./Title.scss");
const Title = _ref => {
  let {
    activeStatuses,
    className,
    lastStatus
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-StatusBarShort-Title', {
    'cds-StatusBarShort-Title--InProgress': lastStatus.status === _.STATUSBAR_STATUS.inProgress && activeStatuses.length > 1,
    'cds-StatusBarShort-Title--AwaitingInProgress': lastStatus.status === _.STATUSBAR_STATUS.inProgress && activeStatuses.length === 1,
    'cds-StatusBarShort-Title--Done': lastStatus.status === _.STATUSBAR_STATUS.done
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, lastStatus.title);
};
exports.Title = Title;
//# sourceMappingURL=Title.js.map